import classNames from "classnames";
import React from "react";

import Dialog from "../dialog/Dialog.jsx";
import Register from "../register/RegisterController.jsx";
import { useIntl, FormattedMessage } from "react-intl";

export default function Welcome(props) {
  const {
    className,
    customer,
    address,
    post_city,
    is_shipping,
    timeframe,
    gmbhName,
    logoSmallUrl,
    colorPrimary,
    conditionsPage,
    registerOverlayActive,
    endDialogActive,
    onEndDialogClick,
    onCloseDialogClick,
    setShowRegistrationForm,
    onRegisterSuccess,
    isDeliveryAddress,
    addInvoicePaymentMethod,
    addSepaPaymentMethod,
    paymentProvider,
    deliveryAlteredText,
  } = props;
  const intl = useIntl();
  return (
    <div className={classNames("welcome", className)}>
      <Register
        isDeliveryAddress={isDeliveryAddress}
        address={address}
        post_city={post_city}
        is_shipping={is_shipping}
        timeframe={timeframe}
        active={registerOverlayActive}
        customer={customer}
        onSuccess={onRegisterSuccess}
        gmbhName={gmbhName}
        logoSmallUrl={logoSmallUrl}
        colorPrimary={colorPrimary}
        conditionsPage={conditionsPage}
        addInvoicePaymentMethod={addInvoicePaymentMethod}
        addSepaPaymentMethod={addSepaPaymentMethod}
        paymentProvider={paymentProvider}
        onCloseDialogClick={onCloseDialogClick}
        setShowRegistrationForm={setShowRegistrationForm}
      />
      <Dialog
        className="welcome__end"
        buttonText={intl.formatMessage({ id: "backToShop" })}
        onButtonClick={onEndDialogClick}
        active={endDialogActive}
      >
        <p>
          <FormattedMessage id="thankYou" />{" "}
        </p>
        <p>
          <FormattedMessage id="successfulRegistration" />
        </p>
        <p>
          <FormattedMessage id="orderConfirmationMail" />
        </p>
        <p>{deliveryAlteredText}</p>
      </Dialog>
    </div>
  );
}
